import BikeElevationInformation, { BikeElevationInfo as info } from './BikeElevationInformation'

export type BikeElevationInfo = info
export default BikeElevationInformation
